import { z } from "zod";

export const createCommentSchema = z
	.object({
		content: z
			.string()
			.min(1, { message: "Comment content is required" })
			.max(5000, { message: "Comment must be at most 5000 characters" }),
		parent_id: z.uuid({ message: "Invalid parent comment ID" }).optional(),
	})
	.strict();

export type CreateCommentPayload = z.infer<typeof createCommentSchema>;
